import ExportDataModal from './ExportDataModal.container'

export default ExportDataModal
